export function yesNoBoolean(value: Boolean) {
	return value ? "Yes" : "No";
}
